function Reducers(state = { list: [] }, action) {
  switch (action.type) {
    case "Add":
      return {
        ...state,
        list: [
          ...state.list,
          {
            id: action.data.id,
            data: action.data.data,
            time: action.data.time,
          },
        ],
      };

    default:
      return state;
  }
}
export default Reducers;
